<template>
  <div class="container flights">
    <div class="block-screen" v-if="loading">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
    <navbar></navbar>
    <modal v-if="message.show" @close="closeModal" :title="message.title" :body="message.body" :type="message.type">
    </modal>
    <main class="row" id="content" v-if="canFlight && !userCompleted">
      <header>
        <h1>Seleção de voos</h1>
        <p>Preencha as informações abaixo relativas à sua viagem.</p>
        <hr />
      </header>
      <div class="col-md-8">
        <tabs>
          <tab id="tab1" name="Acompanhantes" :tabName="tabName" :isValid="true" icon="icon icon-tab4" selected="true">
            <guests-tab :loading="loading" :exceededGuests="exceededGuests" :exceededGuestsExtras="exceededGuestsExtras" :rankMessage="rankMessage"
              :guestsForFlight="guestsForFlight" :checkedNames="checkedNames" :checkedNamesExtras="checkedNamesExtras" @changeTab="changeTab"
              @handleCheckedNames="handleCheckedNames" @handleCheckedNamesExtras="handleCheckedNamesExtras" @showChoiceMsg="showChoiceMsg" @handleLoading="handleLoading">
            </guests-tab>
          </tab>
          <tab id="tab2" name="Voo" :tabName="tabName" :isValid="true" icon="icon icon-tab5">
            <flights-tab :loading="loading" :flights="flights" :$v="$v" :whichFlight="whichFlight"
              :changeDate="changeDate" :confirmInfo="confirmInfo" :account="account" @changeTab="changeTab"
              @handleSelectedFlight="handleSelectedFlight" @handleChangeDate="handleChangeDate"
              @handleConfirmInfo="handleConfirmInfo" @handleLoading="handleLoading" @handleModal="handleModal"
              @handleFlightTab="changeTab('Termo de Imagem')" @handleFlights="handleFlights" :participantRank="participantRank" >
            </flights-tab>
          </tab>
          <tab id="tab3" name="Termo de Imagem" :tabName="tabName" :isValid="true" icon="icon icon-tab7">
            <terms-tab @changeTab="changeTab"></terms-tab>
          </tab>
          <tab id="tab4" name="Adicionais" :tabName="tabName" :isValid="true" icon="icon icon-tab8">
            <additional-tab :participant="user" :accountProp="account" @changeTab="changeTab"
              @handleUserChanged="handleUserChanged" @handleAccountChanged="handleAccountChanged">
            </additional-tab>
          </tab>
          <tab id="tab5" name="Conclusão" :tabName="tabName" :isValid="true" icon="icon icon-tab6">
            <finish-tab :user="user" :account="account" :selectedFlight="selectedFlight" :changeDate="changeDate"
              :isFinished="isFinished" :showEmailMessage="showEmailMessage" @changeTab="changeTab"
              @handleSubmit="sendData" @handleLogout="finish">
            </finish-tab>
          </tab>
        </tabs>
      </div>
      <flight-info :participant="user" :accountProp="account" :tabName="tabName" @handleUserChanged="handleUserChanged"
        @handleAccountChanged="handleAccountChanged" @handleRemovedIssue="removeIssue">
      </flight-info>
      <footer-component></footer-component>
    </main>
  </div>
</template>

<script>
import _ from 'lodash';
import { required } from 'vuelidate/lib/validators';
import { mixin } from '../mixin.js';
import FlightInfo from './FlightInfo.vue';
import Infos from './Infos.vue';
import CustomButtom from './shared/CustomButton.vue';
import Footer from './shared/Footer.vue';
import Modal from './shared/Modal.vue';
import NavBar from './shared/NavBar.vue';
import Tab from './shared/Tab.vue';
import Tabs from './shared/Tabs.vue';
import AdditionalTab from './tabs/Additional.vue';
import FinishTab from './tabs/Finish.vue';
import FlightsTab from './tabs/Flights.vue';
import GuestsTab from './tabs/Guests.vue';
import TermsTab from './tabs/Terms.vue';

export default {
  mixins: [ mixin ],
  data: function () {
    return {
      message: {
        show: false,
        title: '',
        body: '',
        type: false,
        logout: false
      },
      loading: false,
      user: { participant: { extras: {} } },
      tabName: '',
      confirmInfo: false,
      checkedNames: [],
      checkedNamesExtras: [],
      whichFlight: [],
      participantRank: 0,
      flights: [],
      changeDate: false,
      extras: [],
      exceededGuests: false,
      exceededGuestsExtras: false,
      guestsForFlight: [],
      account: {
        issuance: []
      },
      userCompleted: false,
      canFlight: true,
      sync: false,
      rankMessage: '',
      isFinished: false,
      showEmailMessage: false
    }
  },
  components: {
    navbar: NavBar,
    modal: Modal,
    tabs: Tabs,
    tab: Tab,
    infos: Infos,
    'custom-button': CustomButtom,
    'footer-component': Footer,
    'guests-tab': GuestsTab,
    'flights-tab': FlightsTab,
    'additional-tab': AdditionalTab,
    'terms-tab': TermsTab,
    'finish-tab': FinishTab,
    'flight-info': FlightInfo
  },
  validations: {
    whichFlight: { required }
  },
  mounted: function () {
    this.loading = true;
    this.sync = true;

    this.$http.get(`sync`).then((response) => {
      let user = response.data.user;
      this.$store.commit("setUser", response.data.user);

      if (window.localStorage) {
        window.localStorage.setItem("user", JSON.stringify(response.data.user));
      }
      let startEvent = new Date(response.data.configs.startEvent)
      let finalEvent = new Date(response.data.configs.finalEvent)
      this.$store.commit('setStartEvent', startEvent);
      this.$store.commit('setFinalEvent', finalEvent);

      if (user.participant.id === undefined || user.participant.id === false || 
        user.completed === null || response.data.configs.canSelectFlight === false) {
        this.$router.push({name: 'register'});
      }

      this.user = user;

      this.flights = response.data.flights;
      this.guestsForFlight = _.sortBy(response.data.user.participant.guests, o => Number(o.age)).reverse();
      this.guestsForFlight.forEach(guest => {
        guest.disable = false
        for (let key in response.data.kinship) {
          if (key == guest.kinship) {
            guest.formattedKinship = response.data.kinship[key];
          }
        }
      });
      this.whichFlight = [{flight: null, passanger: this.user.participant}];

      this.updateRankMessage();
      this.canFlight = response.data.configs.canFlight;
      if (!this.canFlight) {
        this.openModal(
          'Info',
          'A data limite para seleção de voos e acompanhantes foi excedida.',
          'info'
        )
      }
      this.updateGuestsFlightArray();
      this.participantRank = user.rank;
    });

    this.$http.get(`flights`).then((response) => {
      let participant = response.data.participant;

      if (participant.flight.flight_id !== null) {
        this.openModal(
          'Atenção',
          'Você já selecionou um voo anteriormente e não é possível mudá-lo. Entre em contato com a Origami.'
        )
        this.userCompleted = true;
      }
      this.loading = false;
    })
    .catch((response) => {
      this.loading = false;
      this.sync = false;
    });
  },
  methods: {
    handleModal: function (title, message, type = false) {
      this.openModal(title, message, type)
    },
    handleLoading: function (value) {
      this.loading = value;
    },
    handleCheckedNames: function (array) {
      this.checkedNames = array;
    },
    handleCheckedNamesExtras: function (array) {
      this.checkedNamesExtras = array;
    },
    handleFlights: function (array) {
      this.flights = array;
    },
    handleSelectedFlight: function (value) {
      this.whichFlight = value;
    },
    handleChangeDate: function (value) {
      this.changeDate = value;
    },
    handleConfirmInfo: function (value) {
      this.confirmInfo = value;
    },
    handleUserChanged: function (value) {
      this.user = value;
    },
    handleAccountChanged: function (value) {
      this.account = value;
    },
    handleLoading: function (value) {
      this.loading = value
    },
    openModal: function (title, body, type = false, logout = false) {
      const show = true
      this.message = { show, title, body, type, logout }
    },
    closeModal: function () {
      if (this.message.logout) {
        this.logout();
        return;
      }
      this.$v.whichFlight.$reset();
      this.loading = false;
      this.message = {
        show: false,
        title: '',
        body: '',
        type: false,
        logout: false
      }
    },
    finish: function () {
      this.openModal(
        'Sucesso',
        'Sua escolha foi efetuada com sucesso e você receberá um e-mail com a confirmação dos voos selecionados. Lembramos que caso necessite de algum auxílio, entre em contato com a Origami Turismo, através do Whatsapp <a href="https://wa.me/5521988190007" target="_blank" style="color: white; text-decoration: underline;"><i class="fa fa-whatsapp"></i> +55 21 98819-0007 (clique aqui)</a>.', 'info',
        true
      );
      this.scrollOnTop();
    },
    // showTransferMessage: function () {
    //   this.openModal(
    //     'Atenção',
    //     `É necessário selecionar o tipo de transfer em adicionais. Caso não deseje, selecione a opção 'NÃO QUERO TRANSFER'`
    //   );
    // },
    // showNoTransferMessage: function () {
    //   this.openModal(
    //     'Atenção',
    //     `A não utilização do transfer de ida e/ou retorno após confirmação poderá gerar cobrança por parte da Franqueadora.`
    //   );
    // },
    sendData: function (tab, additional) {
      this.loading = true;
      this.showEmailMessage = true;
      setTimeout(() => {
        let data = {
          flight: this.whichFlight, 
          account: this.account, 
          participant_id: this.$store.state.user.participant.id,
          extras: this.user.participant.extras,
          extend_date: this.changeDate,
          resume: document.getElementById('book-flight-resume').innerHTML
        };
        this.showEmailMessage = false;

        this.$http.post(`flights`, data).then((response) => {
          this.tabName = tab;
          this.loading = false;
          this.isFinished = true;
        })
        .catch((err) => {
          console.error(err);
          if (err.response.data.status === false) {
            this.openModal(
              'Limite de vagas excedido',
              'Infelizmente as vagas do voo selecionado já se esgotaram, por favor retorne e refaça sua escolha nos voos que ainda estão disponíveis.'
            );
            // Update flights availables
            this.$http.get(`sync`).then((response) => {
              this.$emit('handleFlights', response.data.flights);
            });
          } else {
            this.openModal(
              'Erro ao cadastrar',
              'Ocorreu uma falha ao efetuar o preenchimento dos dados. Verifique os campos e tente novamente.'
            )
          }
          this.loading = false;
        });
      },100);
    },
    
    logout: function (modal = false) {
      this.loading = true;
      this.$http.post(`auth/logout`).then((response) => {
      }).finally(() => {
        this.$store.commit('setUser', null);
        this.$store.commit('setToken', null);
        window.localStorage.setItem('client_origami_user', null);
        window.localStorage.setItem('client_origami_token', null);
        this.loading = false;
        this.$router.push({name: 'login'});
      });
    },
    changeTab: function (tab, isInvalid) {
      if (!isInvalid) {
        if (tab === 'Conclusão') {
          if (this.confirmInfo === false) {
              this.openModal(
                'Atenção',
                'É necessário confirmar que as informações fornecidas são verdadeiras para efetuar o cadastro.'
              )
          } else {
            this.tabName = tab;
          }
        } else {
          this.tabName = tab;
        }
      }
    },
    updateGuestsFlightArray: function () {
      this.guestsForFlight.forEach(guest => {
        guest.extra = false;
        guest.checked = false;
      });
      const userRankData = this.getRankData();
      const max = userRankData.qtd;
      this.addToIssuance();
      let maxExtra = 1;
      let checkedGuests = this.guestsForFlight.filter(guest => guest.checked == true);
      // const spouse = checkedGuests.filter(guest => (guest.kinship === "1"  || guest.kinship === "2" || guest.kinship === "3"));
      const otherGuests =  checkedGuests.filter(guest => guest.kinship * 1 >= 5);
      const children =  this.guestsForFlight.filter(guest => guest.kinship === "4");
      if (otherGuests.length === 0 && (this.checkedNames.length >= 1 || this.checkedNamesExtras.length >= 1)) {
        maxExtra = 1 + children.length - max;
      }
      this.exceededGuests = this.checkedNames.length >= max;
      this.exceededGuestsExtras = this.checkedNamesExtras.length !==0 && this.checkedNamesExtras.length >= maxExtra;
    },
    addToIssuance: function () {
      let temp = [];
      this.checkedNames.forEach((item) => {
        this.guestsForFlight.forEach((guest) => {
          if (guest.id === item) {
            temp.push({
              id: guest.id,
              guest: guest.passportFirstName + " " + guest.passportLastName,
              price: 0,
              isExtra: guest.extra,
              ticket: guest.ticket,
              age: Number(guest.age),
              formattedKinship: guest.formattedKinship,
              extras: {
                departure_transfer: false,
                return_transfer: false,
                refuse_transfer: false
              }
            });
            guest.checked = true;
            guest.extra = false;
          }
        });
      });
      this.checkedNamesExtras.forEach((item) => {
        this.guestsForFlight.forEach((guest) => {
          if (guest.id === item) {
            temp.push({
              id: guest.id,
              guest: guest.passportFirstName + " " + guest.passportLastName,
              price: 0,
              isExtra: true,
              ticket: true,
              age: Number(guest.age),
              formattedKinship: guest.formattedKinship,
              extras: {
                departure_transfer: false,
                return_transfer: false,
                refuse_transfer: false
              }
            });
            guest.checked = true;
            guest.extra = true;
          }
        });
      });
      this.account.issuance = temp;
      this.whichFlight = [this.whichFlight[0]];
      this.account.issuance.forEach((issuance) => {
        this.whichFlight.push({flight: null, passanger: issuance, guest: true})
      });
    },
    showChoiceMsg: function () {
      this.openModal(
        'Atenção',
        'Para alterações, dúvidas e sugestões pedimos a gentileza que entre em contato através de nosso canal de atendimento via WhatsApp <a href="https://wa.me/5521988190007" target="_blank" style="color: white; text-decoration: underline;"><i class="fa fa-whatsapp"></i> +55 21 98819-0007 (clique aqui)</a>.'
      )
    },
    // transfer: function (value) {
    //   if (value) {
    //     this.openModal(
    //       'Info',
    //       `Importante: A não utilização do transfer de ida e/ou retorno após confirmação poderá gerar cobrança. Dúvidas? Entre em contato com a área de Marketing Promocional da Franqueadora.`,
    //       'info'
    //     )
    //   }
    // },
    removeIssue: function (id) {
      if (this.checkedNames.includes(id)) {
        this.checkedNames.splice(this.checkedNames.indexOf(id), 1);
      }
      if (this.checkedNamesExtras.includes(id)) {
        this.checkedNamesExtras.splice(this.checkedNamesExtras.indexOf(id), 1);
      }
    },
    updateRankMessage: function () {
      const rankData = this.getRankData();
      this.rankMessage = `Parabéns! Sua franquia se qualificou como ${rankData.rank}. Selecione abaixo os acompanhantes qualicados e extras, se houver, que irão para a PTC 2025.`;
    },
    getRankData: function () {
      const obj = { rank: '', msg: '', extras: 0, qtd: 0 };

      switch(this.user.rank) {
          case 1:
            obj.rank = 'Campeão';
            obj.msg = '3 (três)';
            obj.qtd = 3;
            break;
          case 2:
            obj.rank = 'Super Gold';
            obj.msg = '3 (três)';
            obj.qtd = 3;
            break;
          case 3:
            obj.rank = 'Gold';
            obj.msg = '2 (dois)';
            obj.qtd = 2;
            break;
          case 4:
            obj.rank = 'Silver';
            obj.msg = '1 (um)';
            obj.qtd = 1;
            break;
          case 5:
            obj.rank = 'Bronze';
            obj.msg = '0 (zero)';
            obj.qtd = 0;
            break;
          default:
            break;
      }

      return obj;
    }
  },
  computed: {
    selectedFlight () {
      return this.whichFlight;
    },
    sumValues: function () {
      let sumIssuance = 0;
      this.account.issuance.forEach((guest) => {
        if (guest.isExtra) {
          sumIssuance += guest.price;
        }
        if (guest.extras.bedroom) {
          sumIssuance += 0;
        }
      });
      if (this.user.participant.extras.bedroom) {
        sumIssuance += 0;
      }
      return sumIssuance;
    },
  },
  watch: {
    whichFlight: function (value) {
      if (this.flight && value == this.flight[this.flight.length() -1].id) { // Remover hardcoded de voo de datas oficiais
        this.showChoiceMsg();
      }
    },
    guestsForFlight: {
      handler: function (after, before) {
        this.addToIssuance();
      },
      deep: true
    },
    checkedNames: function () {
      this.updateGuestsFlightArray();
      // this.checkedNamesExtras = [];
    },
    checkedNamesExtras: function () {
      this.updateGuestsFlightArray();
    },
    changeDate: function (value) {
      if (value) {
        this.showChoiceMsg();
      }
    },


  }
}
</script>

<style lang="scss" scoped>
@import "../../src/assets/css/variables";

.obs-text {
  width: 100%;
  padding-bottom: 4px;
  background-color: #fff;
}

.resume-extras {
  margin-left: 20px;
  margin-top: -25px;
}

.total-value {
  color: $brand-color;
  margin-top: 0;
}

.extend {
  @include rise();
}

aside {
  [class^="col"]:nth-child(1) {
    > h3 {
      position: relative;
      color: $brand-color;

      i {
        margin-right: 1em;
      }

      span {
        position: absolute;
        font-size: 0.8em;
        color: $secondary-text-color;
        line-height: 1.4;
        right: 0;
      }
    }
  }
}

.guests-extras {
  background-color: rgba(0, 34, 71, 0.04);
  align-items: stretch;
  margin: 0;
  padding: 1rem;
}

.guests-info {
  cursor: pointer;
  float: right;
  padding: 0;
  margin-top: -1.5rem;
  align-self: flex-start;
  a {
    text-decoration: none;
    color: rgba(0, 34, 71, 0.75);
  }
  a.hidden-xs {
    text-transform: uppercase;
    font-size: 0.667em;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Flight.vue